import React from "react"
import Checkboxes from "./Checkboxes"
import "./Section.06.Weather.css"

export default function WeatherSection(params) {

    const {rescue, values} = params
    
    return <li className="accordion">
        <input type="checkbox" className="accordion" name="accordion" id="acc-weather"/>
        <label className="accordion" htmlFor="acc-weather">Meteorološki uslovi</label>
        <section className="accordion">
            <div className="field full">
                <Checkboxes values={values?.weathers} selected={rescue.rescue.weather} onChange={list => rescue.setField("weather", list)}/>
                <input type="text" value={rescue.rescue.weather_desc || ''} id="weather_desc" className="underline" placeholder="Nešto drugo..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
            </div>
        </section>
    </li>
}